<template>
  <el-dialog
    class="cash-handover-dialog"
    :visible.sync="dialogVisible"
    width="1120px"
    :close-on-click-modal="false"
    :show-close="false"
    append-to-body
  >
    <template slot="title">
      <div class="cash-handover-dialog__header">
        <div class="cash-handover-dialog__title">{{ dialogTitle }}</div>
        <button type="button" class="cash-handover-dialog__close" @click="handleClose">
          <i class="el-icon-close"></i>
        </button>
      </div>
    </template>

    <div class="cash-handover-dialog__body">
      <div v-if="showLinkSection" class="cash-handover-dialog__top">
        <div class="cash-handover-dialog__text">
          <span>{{ linkLabel }} </span>
          <a :href="payLink" target="_blank" rel="noopener noreferrer">{{ payLink }}</a>
        </div>

        <el-button class="cash-handover-dialog__copy" plain @click="copyLink">
          <i class="el-icon-document-copy"></i>
          Sao chép link
        </el-button>
      </div>
      <div class="cash-handover-dialog__intro mb-2">Số tiền cần thanh toán: {{ paymentSource.payment_amount }}</div>
      <div class="cash-handover-dialog__intro">{{ introText }}</div>
      <div class="cash-handover-dialog__step">{{ stepText }}</div>

      <div class="cash-handover-dialog__transfer">
        <div class="cash-handover-dialog__qr">
          <img :src="qrText" alt="" style="height: 190px">
        </div>
        <div class="cash-handover-dialog__bank">
          <div>- {{ bankName }}</div>
          <div>- Chủ tài khoản: {{ accountName }}</div>
          <div>- Số tài khoản: {{ accountNumber }}</div>
          <div>- Nội dung chuyển khoản: {{ transferContent }}</div>
        </div>
      </div>

      <div v-if="showSecondStep" class="cash-handover-dialog__step cash-handover-dialog__step--second">
        Bước 2: Hoàn tất thông tin sau tin nhắn xác nhận chuyển tiền
      </div>
      <div v-if="showSecondStep" class="cash-handover-dialog__paragraph">
        Trung tâm sẽ nhắn tin tới số điện thoại khách hàng trong nội dung chuyển khoản để xác nhận thông tin chuyển tiền
        và gửi mã dự thi muộn nhất trong vòng 4h (theo giờ hành chính) sau khi nhận được tiền. Trường hợp không nhận
        được tin nhắn, bạn vui lòng báo học viên liên hệ qua tổng đài để được xử lý.
      </div>
      <div v-if="showSecondStep" class="cash-handover-dialog__paragraph">
        Trung tâm không chịu trách nhiệm nếu trong quá trình chuyển khoản sai thông tin. Trong một số tình huống cụ
        thể, khách hàng có thể nhờ phía Ngân hàng thực hiện chuyển khoản hoặc Ngân hàng thụ hưởng của trung tâm để
        kiểm tra đối chứng cần thiết. Ngay khi nhận được xác nhận từ Ngân hàng, trung tâm sẽ tiến hành thủ tục tiếp
        theo cho khách hàng.
      </div>
    </div>

    <template slot="footer">
      <div class="cash-handover-dialog__footer">
        <el-button class="cash-handover-dialog__close-btn" @click="handleClose">Đóng</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: "CashHandoverDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: "transfer",
    },
    payLink: {
      type: String,
      default: "",
    },
    paymentOption: {
      type: [Object, Array],
      default: () => ({}),
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      },
    },
    isCashMode() {
      return this.mode === "cash";
    },
    showLinkSection() {
      return !this.isCashMode;
    },
    showSecondStep() {
      return !this.isCashMode;
    },
    dialogTitle() {
      return this.isCashMode
        ? "Bàn giao tiền cọc về công ty"
        : "Hướng dẫn học viên thanh toán cọc qua hình thức chuyển khoản";
    },
    linkLabel() {
      return this.isCashMode
        ? "Vui lòng nhắc học viên chuyển khoản tiền cọc theo link:"
        : "Vui lòng nhắc nhở khách hàng thanh toán cọc qua link:";
    },
    introText() {
      return this.isCashMode
        ? "Chuyển khoản tiền cọc của học viên về công ty theo hướng dẫn:"
        : "Bạn có thể gửi mã QR này cho khách hàng:";
    },
    stepText() {
      return this.isCashMode
        ? ""
        : "Bước 1: Chuyển khoản phí thi lại theo hướng dẫn";
    },
    paymentSource() {
      if (Array.isArray(this.paymentOption)) {
        return this.paymentOption[0] || {};
      }
      return this.paymentOption || {};
    },

    qrText() {
      const  description= this.paymentSource?.payment_code;
      const bank = (this.paymentSource?.bank_name || '').toString().trim();
      const acc = (this.paymentSource?.bank_account_number || '').toString().trim();
      const des = (description || '').toString().trim();
      const amount = this.paymentSource.payment_amount;
      if (!bank || !acc || !des) return '';
      const desContent = `SF${des}`;
      let url = `https://qr.sepay.vn/img?bank=${encodeURIComponent(bank)}&acc=${encodeURIComponent(acc)}&template=compact&des=${encodeURIComponent(desContent)}`;
      if (amount) url += `&amount=${encodeURIComponent(amount)}`;
      return url;
    },
    bankName() {
      return this.paymentSource.bank_name || "Ngân hàng thương mại cổ phần Quân đội MBBank";
    },
    accountName() {
      return this.paymentSource.account_name || "Hồ Văn Hoàn";
    },
    accountNumber() {
      return this.paymentSource.bank_account_number || "4666999666999";
    },
    transferContent() {
      return this.paymentSource.transfer_content || this.paymentSource.payment_code || "TLFHKSKKSJ 0375556173";
    },
  },
  methods: {
    async copyLink() {
      if (this.isCashMode) {
        return;
      }

      try {
        await navigator.clipboard.writeText(this.payLink);
        this.$message.success("Đã sao chép link");
      } catch (error) {
        const input = document.createElement("input");
        input.value = this.payLink;
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        document.body.removeChild(input);
        this.$message.success("Đã sao chép link");
      }
    },
    handleClose() {
      this.$emit("update:visible", false);
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.cash-handover-dialog__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.cash-handover-dialog__title {
  font-size: 15px;
  font-weight: 500;
  color: #222;
  line-height: 1.4;
}

.cash-handover-dialog__close {
  border: 0;
  background: transparent;
  color: #6b7280;
  font-size: 22px;
  line-height: 1;
  padding: 0;
}

.cash-handover-dialog__body {
  color: #111827;
  font-size: 15px;
  line-height: 1.45;
}

.cash-handover-dialog__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 10px;
}

.cash-handover-dialog__text {
  min-width: 0;
}

.cash-handover-dialog__text a {
  color: #1677ff;
  word-break: break-all;
}

.cash-handover-dialog__copy {
  border-style: dashed;
  border-color: #f59e0b;
  color: #3f3f46;
  background: #fff;
  white-space: nowrap;
}

.cash-handover-dialog__copy:hover,
.cash-handover-dialog__copy:focus {
  border-color: #f59e0b;
  color: #3f3f46;
  background: #fff8ed;
}

.cash-handover-dialog__intro,
.cash-handover-dialog__step {
  margin-top: 10px;
}

.cash-handover-dialog__transfer {
  display: flex;
  align-items: flex-start;
  gap: 22px;
  margin-top: 8px;
}

.cash-handover-dialog__qr {
  flex: 0 0 auto;
  width: 200px;
  min-height: 200px;
}

.cash-handover-dialog__bank {
  flex: 1 1 auto;
  padding-top: 12px;
  font-size: 16px;
  line-height: 1.35;
}

.cash-handover-dialog__paragraph {
  margin-top: 12px;
}

.cash-handover-dialog__footer {
  display: flex;
  justify-content: flex-end;
}

.cash-handover-dialog__close-btn {
  min-width: 88px;
  background: #d9d9d9;
  border-color: #d9d9d9;
  color: #222;
}

.cash-handover-dialog__close-btn:hover,
.cash-handover-dialog__close-btn:focus {
  background: #cfcfcf;
  border-color: #cfcfcf;
  color: #222;
}

@media (max-width: 768px) {
  .cash-handover-dialog__top,
  .cash-handover-dialog__transfer {
    flex-direction: column;
  }

  .cash-handover-dialog__copy {
    width: 100%;
  }

  .cash-handover-dialog__qr {
    width: 100%;
    display: flex;
    justify-content: center;
  }
}
</style>
